import './CountryPage.css';

export const Requirements = ({ country }) => {
    return (
        <div className="main-content">
            <section className="requirements">
                <h2>Requirements</h2>
                <div className="requirements-list">
                    {country.requirements.map((requirement, index) => (
                        <div key={index} className="requirement-item">
                            <i className="fas fa-plus"></i>
                            <span>{requirement}</span>
                        </div>
                    ))}
                </div>
            </section>
        </div>
    )
}